import type { Group } from '@atlassian/aiops-group-common';
import type { NewSNRPredictionType, SNRActionType } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import { type AISuggestions } from '../../common/types';
import { withAIOpsPrefix } from '../../common/utils';

export const getHeaderDetails = (groupId: string) =>
	fetch<Group>(withAIOpsPrefix(`/v1/group-insights/${groupId}`), {
		exactUrl: true,
	});

export const getAISuggestions = (groupId: string) =>
	fetch<AISuggestions>(withAIOpsPrefix(`/v1/group-insights/getSimilar/${groupId}`), {
		exactUrl: true,
	});

export const addGroupAssignee = (groupId: string, assigneeId: string) =>
	fetch<Group>(withAIOpsPrefix(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
		method: 'PUT',
		exactUrl: true,
	});

export const updateGroupSNRDetails = ({
	id,
	prevPrediction,
	newPrediction,
	action,
}: {
	action: SNRActionType;
	id: string;
	newPrediction: NewSNRPredictionType;
	prevPrediction: NewSNRPredictionType;
}) => {
	return fetch<{
		failedRecords?: number;
		snrResponse: Group | null;
	}>(withAIOpsPrefix(`/v1/group-insights/${id}/snr-details`), {
		method: 'POST',
		body: {
			id,
			type: 'group',
			prevPrediction,
			newPrediction,
			action,
		},
		exactUrl: true,
	});
};
